<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <!-- Linha 1 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Total Espigas com Morte Prematura</mat-label>
                                <input matInput id="txtEspigasMortePrematura" #txtEspigasMortePrematura maxlength="3"
                                    formControlName="total_espigas_morte_prematura" currencyMask (blur)="makeCalculations()"
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtEspigasMortePrematura.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.total_espigas_morte_prematura)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor"> Morte Prematura (%)
                                </mat-label>
                                <input matInput id="txtMortePrematuraPrc" #txtMortePrematuraPrc maxlength="3"
                                    formControlName="morte_prematura_prc" readonly class="InputBlockColor" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 1 }">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtMortePrematuraPrc.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.morte_prematura_prc)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>